import React from 'react';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import LifetimeReviewVolumeByStarRatingChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewAnalysis/LifetimeReviewVolumeByStarRatingChart';
import ProductCatalogCountReviewRatingChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewAnalysis/ProductCatalogCountReviewRatingChart';
import ReviewDonutAndTopEntityChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewAnalysis/ReviewDonutAndTopEntityChart';
import ReviewDoubleDropdownTopEntityChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewAnalysis/ReviewDoubleDropdownTopEntityChart';
import ReviewProductCatalogCountByCumulativeVolumeChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewAnalysis/ReviewProductCatalogCountByCumulativeVolumeChart';
import WeeklyReviewProductChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewAnalysis/WeeklyReveiwProductChart';
import WeeklyReviewVolumeByStarRatingChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewAnalysis/WeeklyReviewVolumeByStarRatingChart';
import WeeklyReviewVolumeChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewAnalysis/WeeklyReviewVolumeChart';
import ReviewSummaryProductGrid from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewSummary/ReviewSummaryProductGrid';
import { useReviewCumulativeValues } from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewsHooks';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { EntityNoDataPlaceHolder } from 'src/components/BeaconV2Components/common/NoDataPlaceHolder/NoDataPlaceHolder';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import { useCategoryEntity, useProductEntity, useSubcategoryEntity } from 'src/utils/Hooks/reduxSelectors';
import { ChartContextProvider } from 'src/utils/chartContext/ChartContextGroupContext';
import { CHART_CONTEXT_GROUPS, CHART_NAMES } from 'src/utils/chartContext/chartContextRegistry';

const ReviewAnalysisPage = () => {
  const { reviewCumulativeCountData, reviewCumulativeCountLoading } = useReviewCumulativeValues({
    aggregationFieldNames: ['childLifetimeRatingVolume']
  });

  const { isProductEntity } = useProductEntity();
  const { isCategoryEntity } = useCategoryEntity();
  const { isSubcategoryEntity } = useSubcategoryEntity();

  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        {!reviewCumulativeCountLoading && reviewCumulativeCountData?.length === 0 ? (
          EntityNoDataPlaceHolder
        ) : (
          <>
            <ChartContextProvider
              group={CHART_CONTEXT_GROUPS.BEACON_REVIEW_QUALITY_SCORE.name}
              chartName={CHART_NAMES.BEACON_REVIEW_QUALITY_SCORE_COLUMN}
              chartTitle="Review Quality Score"
            >
              <ReviewDonutAndTopEntityChart />
            </ChartContextProvider>
            <ChartContextProvider
              group={CHART_CONTEXT_GROUPS.BEACON_WEEKLY_REVIEW_VOLUME.name}
              chartName={CHART_NAMES.BEACON_WEEKLY_REVIEW_VOLUME_SPLINE}
              chartTitle="Weekly Review Volume"
            >
              {isProductEntity ? <WeeklyReviewProductChart /> : <WeeklyReviewVolumeChart />}
            </ChartContextProvider>
            <ChartContextProvider
              group={CHART_CONTEXT_GROUPS.BEACON_WEEKLY_REVIEW_BY_STAR.name}
              chartName={CHART_NAMES.BEACON_WEEKLY_REVIEW_BY_STAR_COLUMN}
              chartTitle="Weekly Review Volume by Star Rating"
            >
              <WeeklyReviewVolumeByStarRatingChart />
            </ChartContextProvider>
            <ChartContextProvider
              group={CHART_CONTEXT_GROUPS.BEACON_LIFETIME_REVIEW_BY_STAR.name}
              chartName={CHART_NAMES.BEACON_LIFETIME_REVIEW_BY_STAR_COLUMN}
              chartTitle="Cumulative Review Volume by Star Rating"
            >
              <LifetimeReviewVolumeByStarRatingChart />
            </ChartContextProvider>
            {!isProductEntity && (
              <ChartContextProvider
                group={CHART_CONTEXT_GROUPS.BEACON_REVIEW_CATALOG_COUNT_VOLUME.name}
                chartName={CHART_NAMES.BEACON_REVIEW_CATALOG_COUNT_VOLUME_COLUMN}
                chartTitle="Product Catalog Count by Review Volume"
              >
                <ReviewProductCatalogCountByCumulativeVolumeChart />
              </ChartContextProvider>
            )}
            {!isProductEntity && (
              <ChartContextProvider
                group={CHART_CONTEXT_GROUPS.BEACON_REVIEW_CATALOG_COUNT_RATING.name}
                chartName={CHART_NAMES.BEACON_REVIEW_CATALOG_COUNT_RATING_COLUMN}
                chartTitle="Product Catalog Count by Review Rating"
              >
                <ProductCatalogCountReviewRatingChart />
              </ChartContextProvider>
            )}
            {!isCategoryEntity && !isSubcategoryEntity && !isProductEntity && (
              <ChartContextProvider
                group={CHART_CONTEXT_GROUPS.BEACON_REVIEW_BY_CATEGORY.name}
                chartName={CHART_NAMES.BEACON_REVIEW_BY_CATEGORY_COLUMN}
                chartTitle="Reviews by Category"
              >
                <ReviewDoubleDropdownTopEntityChart groupByField="categoryId" />
              </ChartContextProvider>
            )}
            {!isSubcategoryEntity && !isProductEntity && (
              <ChartContextProvider
                group={CHART_CONTEXT_GROUPS.BEACON_REVIEW_BY_SUBCATEGORY.name}
                chartName={CHART_NAMES.BEACON_REVIEW_BY_SUBCATEGORY_COLUMN}
                chartTitle="Reviews by Subcategory"
              >
                <ReviewDoubleDropdownTopEntityChart groupByField="subCategoryId" />
              </ChartContextProvider>
            )}
            {/* Product/Review card grid */}
            <ReviewSummaryProductGrid metric="reviews" tableComponent="review" />
          </>
        )}
      </Flex>
    </BasePageContainer>
  );
};

export default ReviewAnalysisPage;
